import React from "react";
import { Box, Grid } from "@mui/material";

export const OPTION_GRID_CELL_SX = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  minHeight: 0,
  width: "100%",
};

/**
 * One option tile in a responsive 12-column grid.
 * Defaults: 4 columns on sm+ (`sm={3}`), 2 on xs (`xs={6}`).
 * @param {React.ReactNode} children - typically `<Option />`
 * @param {number} [xs=6] - MUI Grid `xs` (12 ÷ mobile columns)
 * @param {number} [sm=3] - MUI Grid `sm` (12 ÷ desktop columns)
 */
export default function OptionGridCell({ children, gridKey, itemSx }) {
  return (
    <Grid item xs={6} sm={6} md={3} xl={2} key={gridKey} sx={{ display: "flex", ...itemSx }}>
      <Box sx={OPTION_GRID_CELL_SX}>{children}</Box>
    </Grid>
  );
}
